import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";
import { useState } from "react";

const Titulo = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
    text-align: center;
`
const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
`
const BotoesWrapper = styled.div`
    margin-top: 35px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`
const Botao = styled.button`
    padding: 9px 12px;
    background-color: ${props => props.cancel ? '#e5e7eb' : '#2563eb'};
    color: ${props => props.cancel ? '#333' : 'white'};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: .2s all ease;
    &:disabled {
        background-color: ${props => props.cancel ? '#e5e7eb' : '#93c5fd'};
        cursor: auto;
    }
`

const ConfirmDeleteEmailBM = ({ id, fecharModal, onDelete }) => {

    const api = useApi();

    const [ saving, setSaving ] = useState(false);

    const handleDelete = async () => {

        setSaving(true);

        try{

            const { data } = await api.post(`/Painel/API/ControleMedicao/DeleteEmailBM/index.php?id=${id}`);
            console.log(data);

            onDelete();
            fecharModal();

        }catch( error ){

            console.error("Erro ao excluir email:", error);

        }finally{

            setSaving(false);

        }

    }

    return(
        <>
            <Overlay state={ true } >
                <Modal size="sm" >
                    <Titulo>Confirmar exclusão</Titulo>
                    <Subtitulo>Tem certeza que deseja excluir este email?</Subtitulo>
                    <BotoesWrapper>
                        <Botao
                            cancel
                            onClick={fecharModal}
                            disabled={ saving }
                        >CANCELAR</Botao>
                        <Botao
                            onClick={handleDelete}
                            disabled={ saving }
                        >EXCLUIR</Botao>
                    </BotoesWrapper>
                </Modal>
            </Overlay>
        </>
    )

}

export default ConfirmDeleteEmailBM;